import { put } from 'redux-saga/effects';
import { updateMapResponse } from '../../actions/map';
import { mapWidgetModel, mapConnectorModel, getDataFromModel } from '../../../helpers/models';

export default function* updateMapSaga(getFirebase, action) {
  const { payload: { projectId, widgets, connectors } } = action;
  try {
    const newWidgets = Object.keys(widgets).reduce((previous, key) => {
      const tmp = previous;
      tmp[key] = getDataFromModel(widgets[key], mapWidgetModel);
      return tmp;
    }, {});

    const newConnectors = Object.keys(connectors).reduce((previous, key) => {
      const tmp = previous;
      tmp[key] = getDataFromModel(connectors[key], mapConnectorModel);
      return tmp;
    }, {});

    getFirebase().update(`/projects/${projectId}/map/connectors`, newConnectors);
    getFirebase().update(`/projects/${projectId}/map/widgets`, newWidgets);
    yield put(updateMapResponse(widgets, connectors));
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/map/UpdateMapSaga.js